/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { translateAuto } from "../../../../../_helpers/AtHelper";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function SearchResult({ data, searchValue, setSearchValue }) {
  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <div
        style={{ maxHeight: "325px", overflow: "hidden" }}
        className="scroll ps ps--active-y"
      >
        <div className="quick-search-result">
          <div className="">{translateAuto("No_record_found")}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{ maxHeight: "325px", overflow: "hidden" }}
      className="scroll ps ps--active-y mt-3"
    >
      <PerfectScrollbar
        options={perfectScrollbarOptions}
        className="scroll"
        style={{ maxHeight: "325px", position: "relative" }}
      >
        <div className="quick-search-result pr-4">
          {/* begin: Section */}
          <Link
            className="font-size-sm text-primary font-weight-bolder text-uppercase "
            style={{ position: "absolute", right: "18px" }}
            to={`/search/${searchValue}`}
          >
            {translateAuto("Show_More")}
          </Link>
          <div className="pt-3">
            {data.map((a, i) => {
              let colotCode;
              switch (a.StatusCode) {
                case "DF":
                  colotCode = "#C0C0C0";
                  break;
                case "OP":
                  colotCode = "#4caf50";
                  break;
                case "BK":
                  colotCode = "#8950FC";
                  break;
                case "OFP":
                  colotCode = "#32C5D2";
                  break;
                case "AT":
                  colotCode = "#ff7c43";
                  break;
                case "IT":
                  colotCode = "#6993ff";
                  break;
                case "AR":
                  colotCode = "#FFA800";
                  break;
                case "DL":
                  colotCode = "#009688";
                  break;
                case "CL":
                  colotCode = "#991f17";
                  break;

                default:
                  colotCode = "";
                  break;
              }
              return (
                <>
                  <div
                    className="d-flex align-items-center flex-grow-1"
                    key={i}
                  >
                    {/*begin::Section*/}
                    <div className="d-flex flex-wrap align-items-center justify-content-between w-100">
                      {/*begin::Info*/}
                      <div className="d-flex flex-column align-items-cente py-2 w-75">
                        {/*begin::Title*/}
                        <Link
                          to={`/shipper/Loads/${a.Id}/details`}
                          className="text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1"
                        >
                          {a?.Code}
                        </Link>
                        {/*end::Title*/}
                        {/*begin::Data*/}
                        <span className="text-muted font-weight-bold">
                          {a.FromState !== null
                            ? a.FromCity + ", " + a.FromState
                            : a.FromState}{" "}
                          /{" "}
                          {a.ToState !== null
                            ? a.ToCity + ", " + a.ToState
                            : a.ToState}
                        </span>
                        {/*end::Data*/}
                      </div>
                      {/*end::Info*/}
                      {/*begin::Label*/}
                      <span
                        className="label label-lg label-inline font-weight-bold py-4 text-white"
                        style={{
                          backgroundColor: colotCode,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {a.Status}
                      </span>
                      {/*end::Label*/}
                    </div>
                    {/*end::Section*/}
                  </div>
                </>
              );
            })}
          </div>
          {/* end: Section */}
        </div>
      </PerfectScrollbar>
    </div>
  );
}
